import { gtmNavClick } from './events';

type CMSNavType = 'Primary Nav Menu' | 'Footer Nav Menu';

export const onClickNavInternal = ({
  url,
  title,
  navType,
}: {
  navType: CMSNavType;
  url: string;
  title: string;
}) => {
  const hostname = window.location.origin;
  gtmNavClick({
    navType: navType,
    clickText: title,
    clickUrl: `${hostname}${url}`,
  });
};

export const onClickNavExternal = ({
  url,
  title,
  navType,
}: {
  navType: CMSNavType;
  url: string;
  title: string;
}) => {
  gtmNavClick({
    navType: navType,
    clickText: title,
    clickUrl: url,
  });
};
